module.exports = __webpack_public_path__ + "img/sertifikat-novel.33c1bc48.png";